<template>
    <div class="DshDivider" :id="propsObj._key" :name="propsObj._key">
        <div
            class="DshDivider-divider"
            :style="propsObj._tagKind === 'flag' ? { marginRight:'36px' } : {}"
        >
            <!--  -->
            <div
                v-if="propsObj._tagKind === 'flag'"
                class="DshDivider-divider-flag"
            >
                <Icon size="15" style="margin-top: -1px" :custom="'bico-font ' + propsObj._tagIcon" />
                <p>{{ propsObj._name }}</p>
                <span class="triangle-topleft"></span>
                <span class="triangle-topright"></span>
            </div>

            <!--  -->
            <div
                v-else-if="propsObj._tagKind === 'line'"
                class="DshDivider-divider-line"
            >
                <p>{{ propsObj._name }}</p>
                <span></span>
            </div>

            <!--  -->
            <div
                v-else-if="propsObj._tagKind === 'circle'"
                class="DshDivider-divider-circle"
            >
                <span class="DshDivider-divider-circle-icon"><Icon :custom="'bico-font ' + propsObj._tagIcon" /></span>
                <p>{{ propsObj._name }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import controlMixin from "../controlMixin.js";

    export default {
        name: "DshDivider",
        mixins: [controlMixin],
        props: {},
        data () {
            return {};
        },
        computed: {},
        created () {},
        methods: {}
    };
</script>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/controls/base/DshDivider.vue